var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.233,
    height: 26.233,
    viewBox: "0 0 26.233 26.233",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M23.774,0H2.459A2.462,2.462,0,0,0,0,2.459V23.774a2.462,2.462,0,0,0,2.459,2.459H23.774a2.462,2.462,0,0,0,2.459-2.459V2.459A2.462,2.462,0,0,0,23.774,0ZM24.7,23.774a.923.923,0,0,1-.922.922H2.459a.923.923,0,0,1-.922-.922V2.459a.923.923,0,0,1,.922-.922H23.774a.923.923,0,0,1,.922.922Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M64.386,63.337h-.915V61.019a.769.769,0,0,0-1.537,0v2.318h-.915a.769.769,0,1,0,0,1.537h.915V76.453a.769.769,0,1,0,1.537,0V64.874h.915a.769.769,0,0,0,0-1.537Z",
    transform: "translate(-57.163 -57.163)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M162.977,72.6h-.915V61.019a.769.769,0,0,0-1.537,0V72.6h-.915a.769.769,0,1,0,0,1.537h.915v2.318a.769.769,0,0,0,1.537,0V74.135h.915a.769.769,0,1,0,0-1.537Z",
    transform: "translate(-150.703 -57.163)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M261.568,67.967h-.915V61.019a.769.769,0,0,0-1.537,0v6.949H258.2a.769.769,0,0,0,0,1.537h.915v6.949a.769.769,0,0,0,1.537,0V69.5h.915a.769.769,0,0,0,0-1.537Z",
    transform: "translate(-244.242 -57.163)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M360.159,61.793h-.915v-.775a.769.769,0,0,0-1.537,0v.775h-.915a.769.769,0,1,0,0,1.537h.915V76.453a.769.769,0,0,0,1.537,0V63.331h.915a.769.769,0,0,0,0-1.537Z",
    transform: "translate(-337.782 -57.163)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M93.871,421.75a.769.769,0,1,0,.769.768A.777.777,0,0,0,93.871,421.75Z",
    transform: "translate(-88.331 -400.141)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M192.462,421.75a.769.769,0,1,0,.769.768A.777.777,0,0,0,192.462,421.75Z",
    transform: "translate(-181.871 -400.141)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M291.052,421.75a.769.769,0,1,0,.769.768A.777.777,0,0,0,291.052,421.75Z",
    transform: "translate(-275.409 -400.141)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M389.643,421.75a.769.769,0,1,0,.768.768A.777.777,0,0,0,389.643,421.75Z",
    transform: "translate(-368.949 -400.141)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAudio);
export default __webpack_public_path__ + "static/media/icon-audio.837319cc38b4a9a71c28c6fd87a76eb8.svg";
export { ForwardRef as ReactComponent };